export const daysAgo = days => {
	const date = new Date();

	date.setHours(0);
	date.setMinutes(0);
	date.setSeconds(0);
	date.setDate(date.getDate() - days);

	return date;
};